export default __webpack_public_path__ + "static/media/image - books.19018054.png";